import React, {useState, useEffect} from "react"
import PropTypes from "prop-types"
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
  Row,
  Col, Input, Alert,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container, Card, CardBody, CardTitle, CardText
} from "reactstrap"
import Select from "react-select"
import axios from "axios"
import * as url from "../../helpers/url_helper"
import * as be from 'helpers/backend_helper';
import { Config, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { Link, useHistory, useParams } from "react-router-dom"
import Breadcrumbs from "../../components/Common/Breadcrumb";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined
import BounceLoader from 'react-spinners/BounceLoader'
import MetaTags from 'react-meta-tags'; 


const AddAsset = () => {
    const history = useHistory();
    toastr.options = TOAST_OPTIONS;


    const [isEdit, setIsEdit] = useState(false);
    const [complaints, setComplaints] = useState([])
    const [categories, setCategories] = useState([])

    const [id, setId] = useState('')
    const [refno, setRefNo] = useState('')
    const [name, setName] = useState('')
    const [phone, setPhone] = useState('')
    const [email, setEmail] = useState('')
    const [account, setAccount] = useState('')
    const [address, setAddress] = useState('')
    const [area, setArea] = useState('')
    const [category, setCategory] = useState('')
    const [details, setDetails] = useState('')
    const [status, setStatus] = useState('')
    const [handlerDept, setHandlerDept] = useState('')
    const [assigns, setAssigns] = useState([])
    const [deptList, setDeptList] = useState([])
    const [handler, setHandler] = useState('')
    const [dateTimeAssigned, setDateTimeAssigned] = useState('')
    const [dateTimeRegistered, setDateTimeRegistered] = useState('')
    const [languages, setlanguages] = useState([])
    const [lang, setLang] = useState('Somali')
    const [areas, setAreas] = useState([])

    const [sDate, setSDate]         = useState([new Date()])
    const [eDate, setEDate]         = useState([new Date()])
    const [sArea, setSArea]         = useState('')
    const [sStatus, setSStatus]     = useState('')
    const [sCategory, setSCategory] = useState('')
    const [sRefNo, setSRefNo]       = useState('')
    const [sPhoneNo, setSPhoneNo]   = useState('')
    const [sStaff, setSStaff]       = useState('')
    const [sMine, setSMine]         = useState('')
    const [sDept, setSDept]         = useState('')
    const [sHandler, setSHandler]   = useState('')
    const [userId, setUserId]       = useState('')
    const [userName, setUserName]   = useState('')

    const [logs, setLogs] = useState([])


    const [isLoading, setIsLoading] = useState(false)

    const [general, setGeneral] = useState(true)

   
    const fetchData = () => {
        axios.get(url.COMPLAINTCATEGORIES, Config).then((r)=>{ 
          setCategories(r.data)
        }).catch((e)=>{  
          console.log(e)
        });
        axios.get(`${url.USERS}`, Config).then((r)=>{ 
          setAssigns(r.data)
        }).catch((e)=>{  
          console.log(e);
        });
        axios.get(`${url.TERRITORIES}`, Config).then((r)=>{ 
          setAreas(r.data);
        }).catch((e)=>{  
          console.log(e);
        });
        axios.get(`${url.MESSAGES}`, Config).then((r)=>{
          setlanguages(r.data)
        }).catch((e)=>{
          console.log(e)
        })
        axios.get(url.DEPTS, Config).then((r)=>{ setDeptList(r.data)}).catch((e)=>console.log(e))
        const obj = JSON.parse(localStorage.getItem("authWTUser"));
        setUserId(obj.id)
        setUserName(obj.username)
        setLogs([{"activity": "Registering", "dateTime": formatDate(new Date), "user": obj.username}])

      }
      
      useEffect(() => {
        fetchData();
      },[]);

      const handleAddComplaint = () =>{
        if(name.trim().length < 3){
          toastr.error("Enter complainant's name")
        }else if((phone.trim().length < 10) ){
          toastr.error("Enter valid complainant's phone number")
        }else if(!be.fno(phone)){
          toastr.error("Enter valid complainant's phone number in format +252631234567")
        }else if(address.trim().length < 5){
          toastr.error("Enter complainant's address")
        }else if(lang.length < 3){
          toastr.error("Specify communication language")
        }else if(category.trim() == ""){
          toastr.error("Specify complaint category")
        }else{
          const obj = JSON.parse(localStorage.getItem("authWTUser"));

          const  data = {
              name    : name,
              phone   : phone,
              email   : email,
              account : account.toUpperCase().replace(/\s+/g, ''),
              address : address,
              area    : area,
              type    : category,
              message : details,
              lang    : lang,
              userId  : obj.id,
              action  : "add"
            }
          setIsLoading(true)
          axios.post(url.COMPLAINTS, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == '1'){
              toastr.success(r.data.message)
              history.push("/Complaint-Details")
            }else{
              toastr.error(r.data.message)
            }
            setIsLoading(false)
          }).catch((e)=>{
            console.log(e)
            setIsLoading(false)
          })
        
        }
        
      }

   
    return (
        <>
        <LoadingOverlay
            active={isLoading}
            spinner={<BounceLoader />}
            text='Please wait...' >
            <div className="page-content">
                <MetaTags>
                <title>Assets | {url.COMPANY}</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumbs title={url.COMPANY} breadcrumbItem="Add Asset" />

                               

                    <div>
                        <Row>
                        <Col  xl={12}>
                            <Card>
                                
                                <CardBody>

                             
                                    <Row onClick={()=>{setGeneral(!general)}} >
                                        <Col sm={12}>
                                            <h5 className="text-primary">Scheme</h5>
                                             <hr/>
                                        </Col>
                                    </Row>
                                    {general && ( <>
                                    <Row>
                                        
                                    <Col md={3}>
                                            <div className="mb-3">
                                                <label>Region</label>
                                                <input type='text' className="form-control" value={name} onChange={(e)=>setName(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <label>Cluster</label>
                                                <input type='email' className="form-control" value={email} onChange={(e)=>setEmail(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <label>Area</label>
                                                <input type='text' className="form-control" value={phone}  onChange={(e)=>setPhone(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <label>Scheme</label>
                                                <input type='text' className="form-control" value={account} onChange={(e)=>{setAccount(e.target.value); handleCheckAcc(e.target.value)}}/>
                                            </div>
                                        </Col>
                                        
                                    </Row>
                                    </>
                                    )}
                                    <Row >
                                        <Col sm={12}>
                                            <h5 className="text-primary">Asset Details</h5>
                                             <hr/>
                                        </Col>
                                    </Row>
                                    <Row>
                                        
                                    <Col md={3}>
                                            <div className="mb-3">
                                                <label>Category</label>
                                                <input type='text' className="form-control" value={name} onChange={(e)=>setName(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <label>Type</label>
                                                <input type='email' className="form-control" value={email} onChange={(e)=>setEmail(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <label>Asset Name</label>
                                                <input type='text' className="form-control" value={phone}  onChange={(e)=>setPhone(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <label>Asset No</label>
                                                <input type='text' className="form-control" value={account} onChange={(e)=>{setAccount(e.target.value); handleCheckAcc(e.target.value)}}/>
                                            </div>
                                        </Col>
                                        
                                    </Row>
                                   
                                    

                        
                                    <Row>
                                    <Col>
                                        <div className="modal-footer justify-content-center">
<button type="button" className="btn btn-success" onClick={handleAddComplaint}>Save customer complaint details...</button>

                                  </div>
                                        </Col>
                                    </Row>
                                    </CardBody>
                            </Card>
                            </Col>
                            <Col xl={3}>
                                <Card>
                                    <CardBody>
                                        <Row>
                                            <Col sm={12}>
                                                <h5 className="text-primary">Logs</h5>
                                                <hr/>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                            <div>
                                                <ul className="verti-timeline list-unstyled">
                                                {logs.map((l,k)=>(
                                                    <li key={k} className="event-list">
                                                    <div className="event-timeline-dot">
                                                        <i className="bx bx-right-arrow-circle" />
                                                    </div>
                                                    <div className="d-flex">
                                                        <div className="me-3">
                                                        <i className="bx bx-copy-alt h2 text-primary" />
                                                        </div>
                                                        <div className="flex-grow-1">
                                                        <div>
                                                            <h5 className="font-size-14">{l.activity}</h5>
                                                            <p className="text-muted">
                                                            {l.dateTime}<br/>{l.user}
                                                            </p>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    </li>
                                                ))}
                        
                                                </ul>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                           
                        </Row>
                    </div>
                </Container>  
            </div>
            </LoadingOverlay>
        </>
    );
}

export default AddAsset;